import React, { useEffect } from "react";
import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import SliderOne from "../assets/1.jpg";
import SliderTwo from "../assets/2.jpg";
import SliderThree from "../assets/3.jpg";
import SliderFour from "../assets/4.jpg";
import SliderFive from "../assets/5.jpg";
import Slidersix from "../assets/6.jpg";
import Header from "../components/Header";
import { Row, Col } from "react-bootstrap";
import Lehnga from "../assets/Images/lehnga.avif";
import Alia from "../assets/Images/alia.avif";
import Kareena from "../assets/Images/kareena.avif";
import Kiara from "../assets/Images/kiara.avif";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { enqueueSnackbar } from "notistack";

const Home = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const [catalogs, setCatalogs] = useState([]); // State to store fetched catalogs
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(false); // State to manage error state

  const getAllCatalogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        // "https://naqshzari.com/backend/public/api/get-all-categories",
        "https://naqshzari.com/backend/public/api/get-all-catalogs?take=4",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCatalogs(response.data.data);
      } else {
        enqueueSnackbar("Internal Server Error", {
          variant: "error",
          autoHideDuration: 2000,
        });
        setError(true);
      }
    } catch (error) {
      enqueueSnackbar("Internal Server Error", {
        variant: "error",
        autoHideDuration: 2000,
      });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCatalogs(); // Fetch catalogs on component mount
  }, []);

  return (
    <>
      <Header />
      <div className="main-slider">
        <Swiper
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000, // 3 seconds delay for autoplay
            disableOnInteraction: false, // Allows autoplay to continue after interaction
          }}
          navigation={true}
          loop={true}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img style={{ width: "1583px", height: "756px" }} src={SliderOne} />
          </SwiperSlide>
          <SwiperSlide>
            <img style={{ width: "1583px", height: "756px" }} src={SliderTwo} />
          </SwiperSlide>{" "}
          <SwiperSlide>
            <img
              style={{ width: "1583px", height: "756px" }}
              src={SliderThree}
            />
          </SwiperSlide>{" "}
          <SwiperSlide>
            <img
              style={{ width: "1583px", height: "756px" }}
              src={SliderFour}
            />
          </SwiperSlide>
          {/* <SwiperSlide>
            <img  style={{width:"1583px",height:"756px"}} src={SliderFive} />
          </SwiperSlide>
          <SwiperSlide>
            <img  style={{width:"1583px",height:"756px"}} src={Slidersix} />
          </SwiperSlide> */}
        </Swiper>
      </div>
      {/* Main Card Section */}
      {catalogs.length > 0 && (
        <>
          <div className="heading-text">Curated This Season</div>
          <div className="desc-text">
            A blend of classic silhouettes and our signature shine, embodied by
            enigmatic sequins.
          </div>
          <div className="cards-section mt-3">
            <Row>
              {catalogs.length > 0 &&
                catalogs.map((catalog, index) => {
                  return (
                    <Col sm={6} lg={3} key={index}>
                      <div
                        className="card-text-position"
                        onClick={() =>
                          navigate(`/catalog-details/${catalog.slug}`)
                        }
                      >
                        <div
                          className="curated-card"
                          style={{ backgroundImage: `url(${catalog.image})` }}
                        ></div>
                        <div className="d-flex align-items-center justify-content-center card-body-text">
                          <div className="lehnga-text">{catalog.title}</div>
                          <hr />
                        </div>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </>
      )}
      <div className="girl-img">
        <img
          style={{ width: "1583px", height: "756px" }}
          src={SliderFive}
          class="dekshtop_only"
          alt=""
        ></img>
      </div>
      <div className="girl-img mt-3" style={{ marginTop: "0" }}>
        <img
          style={{ width: "1583px", height: "756px" }}
          src={Slidersix}
          width="4678"
          height="2234"
          alt="Fine Jewellery by Manish Malhotra"
        />
      </div>
      {/* <div className="second-swiper">
        <Swiper
          slidesPerView={4.2}
          spaceBetween={30}
          loop={true}
          centeredSlides={true}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000, // 3 seconds between each slide
            disableOnInteraction: false, // Continue autoplay after user interaction
          }}
          breakpoints={{
            // when window width is >= 768px
            320: {
              slidesPerView: 1, // Show 2 slides on tablets (768px and above)
              spaceBetween: 20, // Adjust spacing if needed
            },
            590: {
              slidesPerView: 2, // Show 2 slides on tablets (768px and above)
              spaceBetween: 20, // Adjust spacing if needed
            },
            900: {
              slidesPerView: 3, // Show 2 slides on tablets (768px and above)
              spaceBetween: 20, // Adjust spacing if needed
            },

            1200: {
              slidesPerView: 4.2,
              spaceBetween: 30,
            },
            // when window width is >= 1024px
          }}
          className="mySwiper"
          modules={[Autoplay]}
        >
          <SwiperSlide>
            <img src={Alia} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Kareena} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Kiara} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Alia} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Kareena} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Kiara} />
          </SwiperSlide>
        </Swiper>
      </div> */}
      {/* <div className="video-section mt-5">
        <video
          src="https://admin.manishmalhotra.in/videos/2%202%201.MP4"
          type="video/mp4"
          width="100%"
          height="auto"
          playsinline=""
          loop="loop"
          muted=""
          autoplay="autoplay"
          controls="controls"
        ></video>
        <div className="video-section-text">
          <div className="video-heading">Summer 2024 Collection</div>
          <div
            onClick={() => navigate("/catalog-listing")}
            className="video-btn"
          >
            View the Collection
          </div>
        </div>
      </div>
      <div className="gray-video-section">
        <video
          src="https://admin.manishmalhotra.in/videos/couture_processd.mp4"
          type="video/mp4"
          width="100%"
          height="auto"
          class="dekshtop_only"
          playsinline=""
          loop="loop"
          muted=""
          autoplay="autoplay"
          controls="controls"
        ></video>
      </div> */}

      <div className="gray-video-section"></div>
      <Footer />
    </>
  );
};

export default Home;
